import { useEffect, useState } from 'react'

const useCountdown = (targetDate: Date) => {
  const countDownDate = targetDate.getTime()

  const [countDown, setCountDown] = useState(countDownDate - new Date().getTime())

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime())
    }, 1000)

    return () => clearInterval(interval)
  }, [countDownDate])

  return {
    days: countDown > 0 ? Math.floor(countDown / (1000 * 60 * 60 * 24)) : 0,
    hours: countDown > 0 ? Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) : 0,
    minutes: countDown > 0 ? Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60)) : 0,
    seconds: countDown > 0 ? Math.floor((countDown % (1000 * 60)) / 1000) : 0,
  }
}

export default useCountdown
